import React from "react";

import { useTranslation } from "react-i18next";

import logoESGAwardsTransparent from "assets/images/ESG_Awards_transparent_logo.png";

// Components
import WelcomeModal from "components/home/registerModal/WelcomeModal";
import UserFormModal from "components/home/registerModal/UserFormModal";
import UploadUserFormModal from "components/home/registerModal/UploadUserFormModal";
import FloatingModal from "components/modal/FloatingModal";
import DownloadRFIForm from "components/home/registerModal/DownloadRFIForm";
import PaymentEvidenceForm from "components/home/registerModal/PaymentEvidenceForm";

import { hostedByLogo } from "utils/constants/data";

const RegisterModal = ({
  registerModal,
  onClose,
  handleOpenUserForm,
  handleOpenUploadForm,
  handleOpenDownloadForm,
  handleSubmitBtn,
  handleInputChange,
  userForm,
  loading,
  handleOpenPaymentEvidenceForm,
}) => {
  const { t } = useTranslation();

  return (
    <FloatingModal isOpen={registerModal.isOpenRegisterModal} onClose={onClose}>
      <div className="flex flex-col overflow-y-auto md:flex-row ">
        {/* Left Section */}
        <div className="flex flex-col items-center justify-center w-full md:w-1/2">
          <img
            src={logoESGAwardsTransparent}
            alt="ESG Awards logo"
            className="object-contain w-40 h-auto"
          />
          <h2 className="text-2xl md:text-3xl font-bold text-center text-[#1E1E1E] leading-snug">
            ESG GOVERNANCE
          </h2>
          <h2 className="text-2xl md:text-3xl font-bold text-center text-[#1E1E1E] leading-snug">
            KADIN-GAPPS
          </h2>
          <h2 className="text-2xl md:text-3xl font-bold text-center text-[#1E1E1E] leading-snug">
            INTERNATIONAL AWARDS
          </h2>
          <h2 className="text-2xl md:text-3xl font-semibold text-center text-[#1E1E1E] leading-snug">
            2026
          </h2>
          <h4 className="mt-3 text-sm md:md text-center text-[#1E1E1E] ">
            Presented by
          </h4>
          <div className="flex items-center justify-center mt-2 mb-6">
            {hostedByLogo &&
              hostedByLogo.map((logo, idx) => {
                if (logo && logo.name && logo.name === "GAPPS") {
                  return (
                    <img
                      key={idx}
                      src={logo && logo.image_url}
                      className="w-[130px] h-auto object-contain ml-4 mr-1"
                      alt={`hosted-by-logo-${idx + 1}`}
                    />
                  );
                } else {
                  return (
                    <img
                      key={idx}
                      src={logo && logo.image_url}
                      className="w-[50px] h-auto object-contain"
                      alt={`hosted-by-logo-${idx + 1}`}
                    />
                  );
                }
              })}
          </div>
        </div>

        {/* Divider */}
        <div className="hidden md:block w-[2px] bg-[#8DC63F] my-6"></div>

        {/* Right Section */}
        <div className="w-full p-6 md:w-1/2 overflow-y-auto max-h-[calc(80vh-60px)]">
          <WelcomeModal
            show={
              registerModal?.isOpenRegisterModal &&
              !registerModal?.isOpenUserForm &&
              !registerModal?.isOpenUploadForm &&
              !registerModal?.isOpenDownloadForm &&
              !registerModal?.isOpenPaymentEvidenceForm
            }
            handleOpenUserForm={handleOpenUserForm}
            handleOpenDownloadForm={handleOpenDownloadForm}
            handleOpenPaymentEvidenceForm={handleOpenPaymentEvidenceForm}
          />

          <UserFormModal
            show={
              registerModal?.isOpenRegisterModal &&
              registerModal?.isOpenUserForm &&
              !registerModal?.isOpenUploadForm &&
              !registerModal?.isOpenDownloadForm &&
              !registerModal?.isOpenPaymentEvidenceForm
            }
            handleOpenUploadForm={handleOpenUploadForm}
            handleInputChange={handleInputChange}
            userForm={userForm}
            t={t}
          />

          <DownloadRFIForm
            show={
              registerModal?.isOpenRegisterModal &&
              registerModal?.isOpenDownloadForm &&
              !registerModal?.isOpenUserForm &&
              !registerModal?.isOpenUploadForm &&
              !registerModal?.isOpenPaymentEvidenceForm
            }
            handleInputChange={handleInputChange}
            userForm={userForm}
            handleOpenUploadForm={handleOpenUploadForm}
          />

          <UploadUserFormModal
            show={
              registerModal?.isOpenRegisterModal &&
              registerModal?.isOpenUploadForm &&
              !registerModal?.isOpenUserForm &&
              !registerModal?.isOpenDownloadForm &&
              !registerModal?.isOpenPaymentEvidenceForm
            }
            handleSubmitBtn={handleSubmitBtn}
            handleInputChange={handleInputChange}
            userForm={userForm}
            loading={loading}
          />

          <PaymentEvidenceForm
            show={
              registerModal?.isOpenRegisterModal &&
              registerModal?.isOpenPaymentEvidenceForm &&
              !registerModal?.isOpenUploadForm &&
              !registerModal?.isOpenUserForm &&
              !registerModal?.isOpenDownloadForm
            }
            handleOpenUploadForm={handleOpenUploadForm}
            handleInputChange={handleInputChange}
            userForm={userForm}
            loading={loading}
          />
        </div>
      </div>
    </FloatingModal>
  );
};

export default RegisterModal;
